var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcSocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5805_191418)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5653 100C14.2917 100 10 95.7083 10 90.4347V19.5653C10 14.2917 14.2917 10 19.5653 10H90.431C95.7045 10 99.9963 14.2917 99.9963 19.5653V90.431C99.9963 95.7045 95.7045 99.9963 90.431 99.9963H19.5653V100ZM22.8529 17.438C19.8665 17.438 17.438 19.8665 17.438 22.8529V87.1508C17.438 90.1372 19.8665 92.5657 22.8529 92.5657H87.1508C90.1372 92.5657 92.5657 90.1372 92.5657 87.1508V22.8529C92.5657 19.8665 90.1372 17.438 87.1508 17.438H22.8529Z",
    fill: "url(#paint0_linear_5805_191418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4347 10.7438H19.5653C14.6933 10.7438 10.7438 14.6933 10.7438 19.5653V90.4347C10.7438 95.3067 14.6933 99.2562 19.5653 99.2562H90.4347C95.3067 99.2562 99.2562 95.3067 99.2562 90.4347V19.5653C99.2562 14.6933 95.3067 10.7438 90.4347 10.7438Z",
    fill: "url(#paint1_linear_5805_191418)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4347 10.7438H19.5653C14.6934 10.7438 10.7438 14.6934 10.7438 19.5653V90.431C10.7438 95.3029 14.6934 99.2524 19.5653 99.2524H90.431C95.3029 99.2524 99.2525 95.3029 99.2525 90.431V19.5653C99.2525 14.6934 95.3029 10.7438 90.431 10.7438H90.4347ZM93.3058 87.1471C93.3058 90.5425 90.5426 93.3057 87.1471 93.3057H22.8529C19.4574 93.3057 16.6942 90.5425 16.6942 87.1471V22.8529C16.6942 19.4574 19.4574 16.6942 22.8529 16.6942H87.1508C90.5463 16.6942 93.3095 19.4574 93.3095 22.8529V87.1508L93.3058 87.1471Z",
    fill: "url(#paint2_linear_5805_191418)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.49,
    d: "M98.5124 59.4665V19.5652C98.5124 15.1099 94.8864 11.4875 90.4347 11.4875H19.5653C15.1136 11.4875 11.4876 15.1136 11.4876 19.5652V59.4665H98.5124Z",
    fill: "url(#paint3_linear_5805_191418)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.49,
    d: "M13.8975 80.293V21.2612C13.8975 17.1591 17.2223 13.8344 21.3244 13.8344H89.0289C93.131 13.8344 96.4558 17.1591 96.4558 21.2612V80.293H13.8975Z",
    fill: "url(#paint4_linear_5805_191418)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1471 93.3058H22.8529C19.4574 93.3058 16.6942 90.5426 16.6942 87.1471V22.8529C16.6942 19.4574 19.4574 16.6942 22.8529 16.6942H87.1508C90.5463 16.6942 93.3095 19.4574 93.3095 22.8529V87.1508C93.3095 90.5463 90.5463 93.3095 87.1508 93.3095L87.1471 93.3058ZM22.8529 17.438C19.8665 17.438 17.438 19.8665 17.438 22.8529V87.1508C17.438 90.1372 19.8665 92.5657 22.8529 92.5657H87.1508C90.1372 92.5657 92.5657 90.1372 92.5657 87.1508V22.8529C92.5657 19.8665 90.1372 17.438 87.1508 17.438H22.8529Z",
    fill: "url(#paint5_linear_5805_191418)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M87.1471 17.438H22.8529C19.8665 17.438 17.438 19.8665 17.438 22.8529V23.0834C17.438 20.0971 19.8665 17.6686 22.8529 17.6686H87.1508C90.1372 17.6686 92.5657 20.0971 92.5657 23.0834V22.8529C92.5657 19.8665 90.1372 17.438 87.1508 17.438H87.1471Z",
    fill: "url(#paint6_linear_5805_191418)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9314 35.5347V39.1533C50.9314 41.4181 52.7686 43.2553 55.0335 43.2553C57.2983 43.2553 59.1355 41.4181 59.1355 39.1533V35.5347H50.9351H50.9314Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2153 66.5586V54.1967H42.426V56.9971C41.9017 56.7442 41.3215 56.588 40.6967 56.588C38.495 56.588 36.7099 58.3731 36.7099 60.5748C36.7099 62.7764 38.495 64.5615 40.6967 64.5615C41.3178 64.5615 41.9017 64.4053 42.426 64.1524V66.5549H45.2153V66.5586Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7847 66.5586V54.1967H67.574V56.9971C68.0983 56.7442 68.6785 56.588 69.3033 56.588C71.505 56.588 73.2901 58.3731 73.2901 60.5748C73.2901 62.7764 71.505 64.5615 69.3033 64.5615C68.6822 64.5615 68.0983 64.4053 67.574 64.1524V66.5549H64.7847V66.5586Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5805_191418",
    x1: 55,
    y1: 98.6835,
    x2: 55,
    y2: 9.77686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5805_191418",
    x1: 55,
    y1: 97.9582,
    x2: 55,
    y2: 10.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5805_191418",
    x1: 55,
    y1: 97.9582,
    x2: 55,
    y2: 10.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5805_191418",
    x1: 55,
    y1: 60.6975,
    x2: 55,
    y2: 12.5177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5805_191418",
    x1: 55.1785,
    y1: 82,
    x2: 55.1785,
    y2: 15.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5805_191418",
    x1: 55,
    y1: 97.4004,
    x2: 55,
    y2: 11.8632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5805_191418",
    x1: 55,
    y1: 23.0016,
    x2: 55,
    y2: 17.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5805_191418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcSocket);
export default __webpack_public_path__ + "static/media/ac_socket.61da3608f55a612b2565b7d1b67a246d.svg";
export { ForwardRef as ReactComponent };